const routes = [
  //公交列表
  {
    path: "/futureTransport/busStop",
    name: "busStop",
    meta: {
      title: "",
    },
    component: (resolve) =>
      require(["@/views/futureTransport/busStop/index"], resolve),
  },
  //公交详情
  {
    path: "/futureTransport/busStopDetail",
    name: "busStopDetail",
    meta: {
      title: "",
    },
    component: (resolve) =>
      require(["@/views/futureTransport/busStop/busStopDetail"], resolve),
  },
  /* 路线规划 */
  // 路线规划首页
  {
    path: "/futureTransport/routePlan",
    name: "routePlan",
    meta: {
      title: "",
    },
    component: (resolve) =>
      require(["@/views/futureTransport/routePlan/index"], resolve),
  },
  // 路线规划查询
  {
    path: "/futureTransport/routePlanSearch",
    name: "routePlanSearch",
    meta: {
      title: "",
    },
    component: (resolve) =>
      require(["@/views/futureTransport/routePlan/search"], resolve),
  },
  // 路线规划路线
  {
    path: "/futureTransport/newPlaning",
    name: "newPlaning",
    meta: {
      title: "",
    },
    component: (resolve) =>
      require(["@/views/futureTransport/routePlan/newPlaning"], resolve),
  },
  // 路线规划路线
  {
    path: "/futureTransport/routePlanPlanning",
    name: "routePlanPlanning",
    meta: {
      title: "",
    },
    component: (resolve) =>
      require(["@/views/futureTransport/routePlan/planning"], resolve),
  },
  /** end */
];

export default routes;
